import PropTypes from 'prop-types';

import GenerateButton from "./components/GenerateButton";
import EditButton from "./components/EditButton";
import ValidateButton from "./components/ValidateButton";
import CancelButton from "./components/CancelButton";

ActionBar.propTypes = {
    onGenerate: PropTypes.func,
    onEdit: PropTypes.func,
    onValidate: PropTypes.func,
    onCancel: PropTypes.func,
};

function ActionBar({onGenerate, onEdit, onValidate, onCancel}) {
    return (
        <div style={{
            display: 'flex',
            gap: '10px',
            flexWrap: 'wrap',
            marginTop: '16px'
        }}>
            <GenerateButton onClick={onGenerate} />
            <EditButton onClick={onEdit} />
            <ValidateButton onClick={onValidate} />
            <CancelButton onClick={onCancel} />
        </div>
    );
}

export default ActionBar;
